// extracted by mini-css-extract-plugin
module.exports = {"templateView":"TemplateView_templateView__4XgMD","featured_image":"TemplateView_featured_image__2UNth","description":"TemplateView_description__gwkC8"};